import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'objectLength'})
export class ObjectLength implements PipeTransform {
	transform(object: object): number { return Object.keys(object || {}).length; }
}
